import PasswordItemRule from './password-item.rule';

export default class ExpectSpecialCharRule extends PasswordItemRule {
    // https://stackoverflow.com/questions/32311081/check-for-special-characters-in-string
    checkSpecialChar(str){
       return /[ `!@#§$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(str)
    }

    isValid() {
        return this.checkSpecialChar(this.password.element.value);
    }

    getRuleName() {
        return 'expect-special-char';
    }
}
